import { useTranslations } from '@vocab/react';
import { Box, List, Stack, Text } from 'braid-design-system';

import { TextLink } from 'src/components/Link/Link';
import { TRACKING_CODES } from 'src/constants';

import translations from 'src/pages/LinkYourSoftware/.vocab';

export const ContactInfo = () => {
  const { t } = useTranslations(translations);
  return (
    <Box background="neutralSoftHover" padding="gutter" borderRadius="xlarge">
      <Stack space="medium">
        <Text weight="strong">{t('notWantingToConnect')}</Text>
        <List>
          <Text>
            {t('jobSeekerContact', {
              TextLink: (children) => (
                <TextLink
                  weight="regular"
                  href="/contact-us/"
                  tracking={TRACKING_CODES.contact_us_link_clicked}
                  product="candidate"
                >
                  {children}
                </TextLink>
              ),
            })}
          </Text>
          <Text>
            Employers contact us{' '}
            {t('employerContact', {
              TextLink: (children) => (
                <TextLink
                  weight="regular"
                  href="/contactus/"
                  tracking={TRACKING_CODES.talent_contact_us_link_clicked}
                >
                  {children}
                </TextLink>
              ),
            })}
          </Text>
        </List>
        <Text>
          Or, search for answers in our{' '}
          {t('helpCentre', {
            TextLink: (children) => (
              <TextLink
                weight="regular"
                href="https://help.seek.com.au/employer/s/"
                tracking={TRACKING_CODES.talent_help_center_link_clicked}
                skipResolvedUrl={true}
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
    </Box>
  );
};
